/**
 * のりせんべいLP（新デザイン）— スマホの追従購入ボタン
 *
 * 出どころ: ymy-marketing #92「のりせんべいLPの購入導線を直す」P1-2
 *   LPの真ん中に購入リンクが1本も無い区間が約5画面あり、読者の平均スクロール位置（3.9画面）が
 *   ちょうどその中。画面の下に「商品を見る」を出したままにして、どこで読み終えても押せるようにする。
 *
 * 出す条件（2つとも満たすときだけ）:
 *   1. 最初の画面を過ぎている（スクロール量 > 画面の高さの8割）
 *   2. 商品一覧の段が画面に入っていない（同じ役目のものが2つ並ぶのを防ぐ）
 *
 * ★ 位置は毎回その場で測る（getBoundingClientRect）。
 *   IntersectionObserver でも書けるが、見えている・いないの判定が「いつ更新されたか」に依存して
 *   点検しづらかったので（2026-09-25 にプレビューで実測して取りやめ）、素直に測る形にした。
 *   測るのは1要素だけなので、スクロールのたびに読んでも重くない。
 *
 * このLPで唯一の JS。ライブラリは使わない。要素が無ければ何もしない。
 */
(function () {
  var bar = document.querySelector('[data-nsblp-sticky]');
  if (!bar) return;

  var root = document.documentElement;
  var hideOnId = bar.getAttribute('data-nsblp-hide-on') || 'nsblp-catalog';

  function shouldShow() {
    if (window.scrollY <= window.innerHeight * 0.8) return false;

    var hideOn = document.getElementById(hideOnId);
    if (hideOn) {
      var r = hideOn.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < window.innerHeight;
      if (inView) return false;
    }
    return true;
  }

  function sync() {
    var show = shouldShow();
    bar.hidden = !show;
    // 「上に戻る」ボタンとページ末尾の余白を、バーのぶんだけ持ち上げるための目印
    root.classList.toggle('nsblp-has-sticky', show);
  }

  // requestAnimationFrame で間引く書き方もあるが、
  // 測るのが1要素だけなので、そのまま呼ぶ（間引くと画面が隠れている間は動かず、点検もしづらい）。
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();
